// extracted by mini-css-extract-plugin
export default {"tooltip":"gn-z","sharingV2":"hn-z","sharingIconsV2":"in-z","links":"jn-z","link":"kn-z","facebookV2":"ln-z","twitterV2":"mn-z","pinterestV2":"nn-z"};